const zIndex = {
  back: -1,
  card: 30,
  decorationBack: 10,
  decorationFront: 20,
  foreground: 100,
  modal: 200,
  toolbars: 150,
}

export default zIndex
